import Vue from 'vue'
import Vuex from 'vuex'
import LcvApi from '../services/LcvApi'

Vue.use(Vuex);


export default new Vuex.Store({
    /** Global application state */
    state: {
        trades: [],
        vans: [],
        errors: [],
        trade: null,
        load: null,
        van: null,
        selectedVan: null,
        ready: false,
        gatedLogged: false,
        showGate: false // prevent modal gate
    },

    /** Mutations ( monitored setters ) */
    mutations: {
        tradeList: (state, trades) => state.trades = trades,
        trade: (state, trade) => state.trade = trade,
        load: (state, load) => state.load = load,
        vanList: (state, vans) => state.vans = vans,
        van: (state, van) => state.van = van,
        selectedVan: (state, selectedVan) => state.selectedVan = selectedVan,
        setReady: (state, ready) => state.ready = ready,
        setGatedLogged: (state, logged) => state.gatedLogged = logged,
        addError: (state, error) => state.errors.push(error)
    },

    /** Computed reactive getters */
    getters: {
        getTrades: (state) => state.trades,
        getTrade: (state) => state.trade,
        getLoad: (state) => state.load,
        getVans: (state) => state.vans,
        getVan: (state) => state.van,
        getSelectedVan: (state) => state.selectedVan,
        getReady: (state) => state.ready,
    },

    /** Actions ( logical monitored  mutations against state, can return promises ) */
    actions: {
        loadTrades: (context) => {
            let results = [];

            LcvApi.getTrades(
                (obj) => {
                    if (obj.status === 'success') {
                        results = obj.data;

                        if (results.length) {
                            context.commit('tradeList', results);
                        }
                        context.commit("setReady", true);
                    }
                },
                // eslint-disable-next-line
                (error) => {
                    // context.commit('addError', error);
                    context.commit("setReady", true);
                }
            );
        },

        loadVans: (context, id) => {
            let results = [];

            LcvApi.getVehicles(
                id,
                (obj) => {
                    if (obj.status === 'success') {
                        results = obj.data;
                        context.commit('vanList', results);
                    }
                },
                // eslint-disable-next-line
                (error) => {
                    // context.commit('addError', error);
                }
            );
        }
    }
});